'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    .state('pages.main.archive', {
        url: '/archive',
        template: require('../views/archive.html'),
        controller: 'archiveController',
        controllerAs: 'page',
        data: {
            title: 'Archive',
            daterange: true
        }
    })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/archive.js
 **/